import { render, staticRenderFns } from "./LoadingSlider.vue?vue&type=template&id=1be17bc8"
import script from "./LoadingSlider.vue?vue&type=script&lang=ts"
export * from "./LoadingSlider.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports